module.exports = __webpack_public_path__ + "img/logo.083ed3b8.png";